export default "__VITE_ASSET__B1XEJ8gx__"